import { api, type UploadTicket } from '@/api/client';

/** Upload one scan straight to S3 with the presigned PUT the backend hands out. XHR rather than
 *  fetch so the dialog can show progress on a 1 GB DICOM zip. */
export async function uploadScan(
  file: File,
  onProgress: (sent: number, total: number) => void,
  signal?: AbortSignal,
): Promise<UploadTicket> {
  const contentType = file.type || 'application/octet-stream';
  const ticket = await api.post<UploadTicket>('/api/uploads', {
    filename: file.name,
    bytes: file.size,
    content_type: contentType,
  });
  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(ticket.method, ticket.url, true);
    for (const [k, v] of Object.entries(ticket.headers)) xhr.setRequestHeader(k, v);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded, e.total);
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`upload failed (${xhr.status}): ${xhr.responseText.slice(0, 200) || xhr.statusText}`));
    };
    xhr.onerror = () => reject(new Error('upload failed: network error or the bucket refused the request (CORS)'));
    xhr.onabort = () => reject(new DOMException('upload cancelled', 'AbortError'));
    if (signal) {
      if (signal.aborted) xhr.abort();
      else signal.addEventListener('abort', () => xhr.abort(), { once: true });
    }
    xhr.send(file);
  });
  return ticket;
}

export function acceptsScan(name: string, accept: string[]): boolean {
  const lower = name.toLowerCase();
  return accept.some((suffix) => lower.endsWith(suffix));
}
